import React, { useEffect, useState } from 'react';
import './CookieConsent.css';

const CONSENT_KEY = 'cookie_consent';

function applyConsent(value) {
  if (typeof window.gtag !== 'function') return;

  if (value === 'granted') {
    window.gtag('consent', 'update', {
      analytics_storage: 'granted',
      ad_storage: 'granted',
    });
  } else {
    window.gtag('consent', 'update', {
      analytics_storage: 'denied',
      ad_storage: 'denied',
    });
  }
}

function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);

    if (stored === null) {
      setVisible(true);
    } else {
      applyConsent(stored);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'granted');
    applyConsent('granted');
    setVisible(false);
  };

  const handleRefuse = () => {
    localStorage.setItem(CONSENT_KEY, 'denied');
    applyConsent('denied');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent" role="dialog" aria-live="polite" aria-label="Consentement aux cookies">
      <div className="cookie-consent-container">
        <p className="cookie-consent-text">
          The Recap utilise des cookies de mesure d'audience pour comprendre comment nos lecteurs
          suivent l'actualité retail et e-commerce, et ainsi affiner nos décryptages. Vous gardez
          la main&nbsp;: vos données ne sont collectées qu'avec votre accord.{' '}
          <a href="/mentions-legales" className="cookie-consent-link">
            En savoir plus
          </a>
        </p>
        <div className="cookie-consent-actions">
          <button
            type="button"
            className="cookie-consent-btn cookie-consent-btn-refuse"
            onClick={handleRefuse}
          >
            Refuser
          </button>
          <button
            type="button"
            className="cookie-consent-btn cookie-consent-btn-accept"
            onClick={handleAccept}
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
